// @flow

import * as React from 'react';
import { View } from 'react-native';
import { FormattedMessage } from 'react-intl';
import Title from 'src/components/Title';
import MainWrapper from 'src/components/MainWrapper';

const ActivateTrialPeriod = (): React.Node => (
    // TODO: Display the appropriate message an activate button as well as the time until
    //  the link is active (updated constantly)
    <View>
        <MainWrapper>
            <Title
                text={(
                    <FormattedMessage
                        id="activate-trial-period"
                        defaultMessage="Activate trial period"
                    />
                )}
            />
        </MainWrapper>
    </View>
);

export default ActivateTrialPeriod;
